import { Reveal } from "@/components/Reveal";

// D — Introduction / buyer challenge. Dark section that continues the aircraft scene.
export const Intro = () => (
  <section id="intro" data-testid="intro-section" className="on-dark relative overflow-hidden bg-[var(--navy)] pb-24 pt-20 text-white sm:pb-32 sm:pt-24">
    <div className="wrap grid gap-12 lg:grid-cols-[1.2fr_1fr] lg:gap-20">
      <div>
        <Reveal>
          <p className="eyebrow">
            <span className="no">01</span>
            <span className="rule" />
            BEFORE THE CHIPS FLY
          </p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="headline mt-5 text-4xl sm:text-5xl lg:text-[3.6rem]">
            The drawing is only <span className="font-serif-i text-[#9db8ff]">the beginning.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mt-6 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg [text-wrap:pretty]">
            Before a part reaches your assembly, there are decisions to make.
          </p>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg [text-wrap:pretty]">
            How will its features be machined? What needs to be inspected? What changes when one part becomes a production requirement?
          </p>
          <p className="mt-4 max-w-xl text-base leading-relaxed text-white/75 sm:text-lg [text-wrap:pretty]">
            Start with a manufacturing conversation that takes the whole job into account.
          </p>
        </Reveal>
      </div>
      <div className="flex flex-col justify-end">
        <Reveal delay={0.2}>
          <div className="card-dark p-7 sm:p-9">
            <p className="font-serif-i text-2xl leading-snug text-[#FFC48C] sm:text-[1.7rem]">
              Bring the geometry. The requirements. The difficult questions.
            </p>
            <button
              type="button"
              data-testid="intro-discuss-button"
              className="btn btn-light mt-7"
              onClick={() => { const el = document.getElementById("contact"); if (window.__lenis && el) window.__lenis.scrollTo(el, { offset: -90 }); else el?.scrollIntoView({ behavior: "smooth" }); }}
            >
              Discuss Your Requirements
            </button>
            <img
              src="https://images.pexels.com/photos/10406128/pexels-photo-10406128.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="CNC milling machine cutting metal (illustrative imagery)"
              loading="lazy"
              className="mt-7 h-44 w-full rounded-xl border border-white/10 object-cover"
            />
            <p className="mt-3 font-mono text-[9.5px] tracking-[0.16em] text-white/45">ILLUSTRATIVE IMAGERY — NOT PMP EQUIPMENT</p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
